"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Avatar = _interopRequireDefault(require("../../Avatar/Avatar"));

var _CellWithAvatar = require("./CellWithAvatar.styles");

var _elements = require("../../../styles/elements");

var CellWithAvatar = function CellWithAvatar(_ref) {
  var className = _ref.className,
      data = _ref.data,
      oneLine = _ref.oneLine;
  var hasEmail = !!data.email; // Has an avatar or an email in the same cell with a user

  var emailContent = (0, _react.useMemo)(function () {
    var content = (0, _jsxRuntime.jsx)("span", {
      className: "grui truncate",
      css: [_elements.text.styles.textXs, _elements.text.styles.textMediumDark, _elements.text.styles.fontNormal, process.env.NODE_ENV === "production" ? "" : ";label:content;"],
      title: data.email,
      children: oneLine ? " (".concat(data.email, ")") : data.email
    });

    if (!oneLine) {
      return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsx)("br", {}), content]
      });
    }

    return content;
  }, [data.email, oneLine]);
  return (0, _jsxRuntime.jsxs)("div", {
    css: _CellWithAvatar.styles.base,
    className: className,
    children: [(0, _jsxRuntime.jsx)(_Avatar["default"], {
      avatar: data.avatar,
      userName: data.value,
      size: data.avatarSize,
      bgColor: data.bgColor,
      className: (0, _clsx["default"])('grui', data.avatarSize === 'xl' ? 'mr-10' : 'mr-5')
    }), (0, _jsxRuntime.jsxs)("div", {
      className: "grui truncate",
      children: [data.value ? (0, _jsxRuntime.jsx)("span", {
        title: data.value,
        children: data.value
      }) : (0, _jsxRuntime.jsx)("span", {
        css: [_elements.text.styles.textMediumDark, _elements.text.styles.italic, process.env.NODE_ENV === "production" ? "" : ";label:CellWithAvatar;"],
        children: "Unknown"
      }), hasEmail && emailContent]
    })]
  });
};

CellWithAvatar.propTypes = {
  className: _propTypes.string,
  data: (0, _propTypes.shape)({
    value: _propTypes.string,
    avatarSize: (0, _propTypes.oneOf)(['big', 'small', 'xl']),
    avatar: _propTypes.string,
    bgColor: _propTypes.string
  }).isRequired,

  /**
   * Whether show email in the same line
   */
  oneLine: _propTypes.bool
};
CellWithAvatar.defaultProps = {
  className: undefined,
  oneLine: false
};
var _default = CellWithAvatar;
exports["default"] = _default;
//# sourceMappingURL=CellWithAvatar.js.map